// In-memory scroll position store, keyed by route path.
// Lives for the lifetime of the SPA session (cleared on full reload).
const positions = new Map<string, number>();

export function saveScrollPosition(key: string, y: number) {
  positions.set(key, y);
}

export function getScrollPosition(key: string): number | undefined {
  return positions.get(key);
}

export function clearScrollPosition(key: string) {
  positions.delete(key);
}
